import React, { FC, useEffect, useRef } from 'react';
import * as dashjs from 'dashjs';

interface DashPlayerProps {
    source: string;
    type: 'm4a' | 'mpd';
}

const DashPlayer: FC<DashPlayerProps> = ({ source, type }) => {
    const mediaRef = useRef<HTMLMediaElement>(null);
    const playerRef = useRef<any>(null);

    useEffect(() => {
        if (!mediaRef.current || !source) return;

        const player = dashjs.MediaPlayer().create();
        playerRef.current = player;

        // Сбрасываем позицию воспроизведения
        mediaRef.current.currentTime = 0;

        // Настройка плеера
        player.updateSettings({
            streaming: {
                buffer: {
                    bufferTimeAtTopQuality: 30,
                    bufferTimeAtTopQualityLongForm: 60,
                },
            },
        });

        player.initialize(mediaRef.current, source, true);

        return () => {
            if (playerRef.current) {
                playerRef.current.reset();
                playerRef.current.destroy();
                playerRef.current = null;
            }
        };
    }, [source]);

    return type !== 'm4a' ? (
        <video
            ref={mediaRef as React.RefObject<HTMLVideoElement>}
            className="player-video"
            controls
            style={{ width: '100%', height: '100%' }}
        />
    ) : (
        <audio
            ref={mediaRef as React.RefObject<HTMLAudioElement>}
            // className="player-video"
            controls
            style={{ width: '100%', height: '50px' }}
        />
    );
};

export default DashPlayer;
